import { CategoryState } from "../../types";
import {
    FETCH_ALL_CATEGORY_SUCCESS,
    FETCH_ALL_CATEGORY_REQUEST,
    LOGOUT_USER_REQUEST
} from "../constants";

const initialState: CategoryState = {
  categories: [],
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
  switch (action.type) {
    case FETCH_ALL_CATEGORY_REQUEST:
        return {
            ...state,
            categories: action.payload.allCategories,
        };
    case FETCH_ALL_CATEGORY_SUCCESS:
        return {
            ...state,
            categories: action.payload.allCategories,
        };
    case LOGOUT_USER_REQUEST:
      return initialState;
    default:
      return state;
  }
};
